<script setup lang="ts">
import {computed, PropType} from 'vue';
import date from "@/helper/datetime/date";
import {floatFormat} from "@/helper/amountFormatter";
import {
    Employee,
    EmployeePlannedAbsenceConstraints,
    EmployeePlannedAbsenceConstraintsFragmentFragment
} from "@/graphql/generated/graphql";
import {IonChip} from "@ionic/vue";
import {warning} from "ionicons/icons";

const props = defineProps({
    plannedAbsences: {
        type: Object as PropType<EmployeePlannedAbsenceConstraintsFragmentFragment>,
        required: true
    },
    compact: {
        type: Boolean,
        required: false,
        default: false
    },
    chipped: {
        type: Boolean,
        default: true
    }
})

const azkValue = computed(() => props.plannedAbsences.aZK || 0)
const azkValid = computed(() => props.plannedAbsences.validMonth || undefined)

const text = computed(() => props.compact
    ? `AZK: ${floatFormat(azkValue.value)}h`
    : `Aktuelles AZK: ${floatFormat(azkValue.value)}h (Stand ${azkValid.value ? date.formatKapitelDate(azkValid.value, 'MMMM y') : 'unbekannt'})`
)

</script>

<template>
    <IonChip :color="warning" v-if="chipped">{{text}}</IonChip>
    <span v-else>{{text}}</span>
</template>

<style lang="scss">
</style>
